<template>
  <transition-group name="slide" tag="div" class="ig-cards component row">
    <div
      v-for="(card, index) in cards"
      class="col-xs-6 col-md-4 col-lg-3"
      :key="index"
    >
     <UiCard
       @click="viewImg"
       :media="card"
     />
    </div>
  </transition-group>
</template>

<script>
  import UiCard from '@/components/UiCard'
  import axios from 'axios'
  import {MEL_IG} from "../.env";
  export default {
    name: 'IgCards',

    components: {UiCard},

    data () {
      return {
        cards: [],
      }
    },

    created () {
      // axios.get(`${IG_URL}33086999.93ecca8.ab5458e4958b4c0fb89b4221b24da597`).then(response => {
      //   console.log(response);
      // })
      this.igPhotos();
    },

    // computed: {
    //   cards () {
    //     return this.$store.state.toast.toastsList
    //   }
    // },

    methods: {
      async igPhotos() {
        try {
          const infoSource = await axios.get(`${MEL_IG}`);
          //infoSource.data contails the HTML from Axios
          const jsonObject = infoSource.data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1]
            .slice(0, -1);
          const userInfo =  JSON.parse(jsonObject);
          const mediaArray = userInfo.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0,15);
          for (let media of mediaArray) {
            const pic = media.node;
            //process only if is an image
            if(pic.__typename && pic.__typename !== 'GraphImage'){
              continue;
            }
            //push thumbnail src in the array
            this.cards.push(pic.thumbnail_src);
          }
        } catch (e) {
          console.error('unable to restieve photos. Reason: ' + e.toString());
        }
        console.log(this.cards);
        return this.cards;
      },

      viewImg () {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .ui-toast-list.component {
    top: 50px;
    left: 50px;
    width: 300px;
    position: fixed;
    z-index: 9999;
  }

  .slide-leave-active,
  .slide-enter-active {
    transition: .3s;
  }
  .slide-enter {
    transform: translate(0, 100%);
  }
  .slide-leave-to {
    transform: translate(-200%, 0);
  }

  .ig-cards {
    padding-top: 100px;
    margin: 0 auto;
    width: 80vw;

    .card {
      margin-bottom: 20px;
      padding: 10px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0px 1px 2px 0px rgba(0,0,0,.2);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/IgCards.vue